import { render, staticRenderFns } from "./AvatarSelect.vue?vue&type=template&id=244b3bbb&scoped=true&"
import script from "./AvatarSelect.vue?vue&type=script&lang=js&"
export * from "./AvatarSelect.vue?vue&type=script&lang=js&"
import style0 from "./AvatarSelect.vue?vue&type=style&index=0&id=244b3bbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244b3bbb",
  null
  
)

export default component.exports